import { UserInfoDc } from "@evergis/api";

export class UserInfo {
  firstName: string;

  lastName: string;

  email: string;

  username: string;

  profilePhoto: string;

  hasProfilePhoto: boolean;

  workspace: string;

  isOpenLastProject: boolean;

  roles: string[];

  constructor(rawInfo?: UserInfoDc) {
    const { email, first_name, is_open_last_project, last_name, namespace, has_profile_photo, username, roles } =
      rawInfo || {};

    this.firstName = first_name || "";
    this.lastName = last_name || "";
    this.email = email || "";
    this.username = username || "";
    this.hasProfilePhoto = !!has_profile_photo;
    this.workspace = namespace || "";
    this.isOpenLastProject = !!is_open_last_project;
    this.roles = roles || [];
  }
}
